import * as FiIcons from 'react-icons/fi';

const { FiAlertTriangle, FiClock, FiInfo, FiAlertCircle, FiDollarSign, FiFileText, FiSend, FiPackage, FiTruck } = FiIcons;

// --- MOCK DATA --- //

const alerts = [
  { id: 1, type: 'critical', title: 'Low Stock Alert', message: 'Cavendish Bananas below minimum threshold', time: '2 min ago', icon: FiAlertTriangle },
  { id: 2, type: 'warning', title: 'Delivery Delay', message: 'Order #ORD-2024-0156 delayed by 30 minutes', time: '15 min ago', icon: FiClock },
  { id: 3, type: 'info', title: 'Price Update', message: 'Navel Oranges price decreased by 1.5%', time: '1 hour ago', icon: FiInfo },
  { id: 4, type: 'warning', title: 'Payment Overdue', message: 'Customer ABC123 payment 7 days overdue', time: '2 hours ago', icon: FiAlertCircle }
];

const stockData = [
  { sku: 'APL-001', name: 'Granny Smith Apples', currentStock: 450, minThreshold: 200, maxThreshold: 1000, unitPrice: 15.50, cogs: 12.00, margin: 22.6, status: 'healthy' },
  { sku: 'ORG-023', name: 'Navel Oranges', currentStock: 180, minThreshold: 200, maxThreshold: 800, unitPrice: 18.00, cogs: 14.50, margin: 19.4, status: 'low' },
  { sku: 'BAN-012', name: 'Cavendish Bananas', currentStock: 75, minThreshold: 150, maxThreshold: 600, unitPrice: 12.00, cogs: 9.00, margin: 25.0, status: 'critical' },
  { sku: 'TOM-045', name: 'Beef Tomatoes', currentStock: 320, minThreshold: 100, maxThreshold: 500, unitPrice: 25.00, cogs: 18.00, margin: 28.0, status: 'healthy' }
];

const pricingData = [
  { sku: 'APL-001', name: 'Granny Smith Apples', sellPrice: 15.50, costPrice: 12.00, margin: 22.6, trend: 'up', priceChange: '+2.1%' },
  { sku: 'ORG-023', name: 'Navel Oranges', sellPrice: 18.00, costPrice: 14.50, margin: 19.4, trend: 'down', priceChange: '-1.5%' },
  { sku: 'BAN-012', name: 'Cavendish Bananas', sellPrice: 12.00, costPrice: 9.00, margin: 25.0, trend: 'up', priceChange: '+0.8%' }
];

const inventoryCategories = [
  { name: 'Fruits', totalItems: 245, lowStock: 8, trend: 'up', change: '+5.2%', color: 'emerald' },
  { name: 'Vegetables', totalItems: 189, lowStock: 12, trend: 'down', change: '-2.1%', color: 'blue' },
  { name: 'Herbs', totalItems: 67, lowStock: 3, trend: 'up', change: '+8.7%', color: 'purple' },
  { name: 'Exotic', totalItems: 34, lowStock: 5, trend: 'down', change: '-1.5%', color: 'amber' }
];

const metrics = [
  { title: 'Daily Revenue', value: 'N$ 247,850', change: '+12.5%', trend: 'up', icon: FiDollarSign, color: 'emerald' },
  { title: 'Active Stock Items', value: '1,247', change: '-3.2%', trend: 'down', icon: FiPackage, color: 'blue' },
  { title: 'Orders in Transit', value: '89', change: '+8.1%', trend: 'up', icon: FiTruck, color: 'amber' },
  { title: 'Active Customers', value: '542', change: '+5.7%', trend: 'up', icon: FiIcons.FiUsers, color: 'purple' }
];

const quickActions = [
  { id: 'rfq', title: 'Initiate RFQ', description: 'Request for quotation', icon: FiFileText, color: 'blue' },
  { id: 'order', title: 'Create Order', description: 'New purchase order', icon: FiIcons.FiPlus, color: 'emerald' },
  { id: 'proposal', title: 'Send Proposal', description: 'Customer proposal', icon: FiSend, color: 'purple' },
  { id: 'dispatch', title: 'Dispatch Order', description: 'Ready for delivery', icon: FiTruck, color: 'amber' },
  { id: 'invoice', title: 'Generate Invoice', description: 'Create invoice', icon: FiDollarSign, color: 'red' },
  { id: 'stock', title: 'Update Stock', description: 'Inventory adjustment', icon: FiPackage, color: 'indigo' }
];

const revenueData = [
  { name: 'Mon', revenue: 45000, orders: 23 },
  { name: 'Tue', revenue: 52000, orders: 28 },
  { name: 'Wed', revenue: 48000, orders: 25 },
  { name: 'Thu', revenue: 61000, orders: 32 },
  { name: 'Fri', revenue: 55000, orders: 29 },
  { name: 'Sat', revenue: 67000, orders: 35 },
  { name: 'Sun', revenue: 58000, orders: 31 }
];

// --- MOCK API --- //

const fetchMockData = (data) => {
  return new Promise(resolve => {
    setTimeout(() => {
      resolve(data);
    }, 500 + Math.random() * 1000);
  });
};

export const getAlerts = () => fetchMockData(alerts);
export const getFreshBoardStock = () => fetchMockData(stockData);
export const getFreshBoardPricing = () => fetchMockData(pricingData);
export const getInventoryCategories = () => fetchMockData(inventoryCategories);
export const getMetrics = () => fetchMockData(metrics);
export const getQuickActions = () => fetchMockData(quickActions);
export const getRevenueData = () => fetchMockData(revenueData);
